export const ApplicationVI = {
    "applications": {
        "headingLabel": "Đơn từ",
        "list": "Tất cả đơn từ",
        "reason": "Lý do",
        "paid": "Tính công",
        "owner": "Đơn từ của bạn",
        "approval": "Đơn từ bạn duyệt",
        "department": "Đơn từ phòng ban bạn",
        "forElse": "Tạo hộ người khác",
        "information": "Thông tin chung",
        "generalInformation": "Thông tin chung",
        "employeeApproval": "Người duyệt",
        "employeeApprovalPlaceHolder": "Chọn người duyệt",
        "detail": "Chi tiết",
        message: {
            error: {
                description: "Mô tả là bắt buộc",
                employee: "Chọn nhân sự là bắt buộc"
            }
        },
        attach: "Đính kèm",
        "status": {
            "pending": "Chờ duyệt",
            "approved": "Đã duyệt",
            "all": "Tất cả",
            "reject": "Không duyệt",
            "draft": "Bản nháp",
            "expired": "Hết hạn",
            "inactive": "Không hoạt động",
            "incomplete": "Chưa hoàn thiện",
            "denied": "Từ chối"
        },
        "label": {
            "fullName": "Họ và tên",
            "department": "Phòng ban",
            "jobPosition": "Vị trí",
            "jobTitle": "Chức vụ",
            "status": "Trạng thái",
            "approve": "Người duyệt",
            "description": "Mô tả",
            "actionSend": {
                "add": "Tạo mới và gửi",
                "update": "Cập nhật và gửi"
            }
        },
        "columns": {
            "creator": "Người tạo",
            "employeeCode": "Mã nhân viên",
            "fullName": "Tên nhân viên",
            "status": "Trạng thái",
            "type": "Loại đơn",
            "department": "Phòng ban",
            "position": "Vị trí",
            "dateCreated": "Ngày tạo"
        },
        "rules": {
            "reason": "Chưa nhập lý do"
        },
        "placeholder": {
            "reason": "Chọn lý do",
            "hour": "hh:mm",
            "date": "DD/MM/YYYY",
            employee: "Chọn nhân viên",
            description: "Nhập mô tả"
        },
        "type": {
            "inout": {
                "headingLabel": "Đơn check in check out",
                "ownerId": "Nhân sự cần tạo đơn",
                "ownerIds": "Những nhân sự cần tạo đơn",
                "forElse": {
                    "headingLabel": "Tạo đơn check in check out hộ người khác"
                },
                "addNew": "Tạo mới đơn check in check out",
                "update": "Cập nhật đơn check in check out",
                "information": "Thông tin",
                "date": "Ngày",
                "hour": "Giờ",
                "noShift": "Không có ca",
                "shift": "Ca",
                "reason": "Lý do",
                "penalty": "Phạt tiền",
                "description": "Mô tả",
                "maximum": "Tối đa",
                "detail": "Chi tiết đơn check in check out",
                "createMultiEmployees": "Tạo đơn cho nhiều người",
                "placeholder": {
                    "date": "Chọn ngày",
                    "time": "Chọn giờ",
                    "chooseReason": "Chọn lý do",
                    "ownerIds": "Nhập những nhân viên cần tạo đơn",
                    "ownerId": "Nhập nhân viên cần tạo đơn"
                },
                "option": {
                    "yes": "Có",
                    "no": "Không",
                    "unit/week": "lần/tuần",
                    "units/week": "lần/tuần",
                    "unit/month": "lần/tháng",
                    "units/month": "lần/tháng",
                    "unit/year": "lần/năm",
                    "units/year": "lần/năm"
                },
                "columnsDetail": {
                    "date": "Ngày chốt",
                    "time": "Thời gian",
                    "reason": "Lý do",
                    "fine": "Phạt tiền"
                },
                "validate": {
                    "date": "Chưa nhập ngày",
                    "hour": "Chưa nhập giờ",
                    "reason": "Chưa chọn lý do",
                    "ownerId": "Chưa nhập nhân viên cần tạo đơn"
                }
            },
            "flexible": {
                "headingLabel": "Đơn làm theo chế độ",
                "forElse": {
                    "headingLabel": "Tạo đơn làm theo chế độ hộ người khác"
                },
                fromDate: "Từ ngày",
                toDate: "Đến ngày",
                "infomation": "Chi tiết đơn làm theo chế độ",
                "flexibleAdd": "Tạo mới đơn làm theo chế độ ",
                "flexibleEdit": "Cập nhật đơn làm theo chế độ ",
                "flexibleList": "Danh sách đơn làm theo chế độ",
                "flexibleDelete": "Xóa đơn làm theo chế độ",
                "reason": "Lý do",
                "day1": "Từ Ngày",
                "day2": "Đến ngày",
                "late": "Đi muộn",
                "total": "Tổng giờ",
                "backSoon": "Về sớm",
                "description": "Mô tả",
                "employeeApplicationFlexible": "Nhân sự cần tạo đơn",
                "flexibleInOut": "Đi muộn/Về sớm",
                "flexibleTime": "Thời gian",
                "enterReason": "Chọn lý do",
                "enterADescription": "Nhập mô tả",
                "adSuccess": "Thêm đơn làm theo chế độ thành công !",
                "updateSuccess": "Sửa thông tin đơn làm theo chế độ thành công!",
                "deleteSuccess": "Xoá đơn làm theo chế độ thành công!"
            },
            "resign": {
                "headingLabel": "Đơn xin nghỉ việc",
                "add": "Tạo mới đơn xin nghỉ việc",
                "forElse": {
                    "headingLabel": "Tạo đơn xin nghỉ việc hộ người khác"
                },
                "update": "Cập nhật đơn xin nghỉ việc",
                "detailInformation": "Chi tiết đơn xin nghỉ việc",
                "placeholder": {
                    "reason": "Chọn lý do",
                    "resignationDate": "DD/MM/YYYY",
                    "description": "Nhập mô tả...",
                    "relateObject": "Chọn đối tượng liên quan...",
                    "record": "Chọn bản ghi",
                    "employee": "Chọn nhân sự",
                    address: "Chọn địa chỉ"
                },
                "label": {
                    "reason": "Lý do",
                    "resignationDate": "Ngày nghỉ việc",
                    "description": "Mô tả",
                    "relateObject": "Đối tượng liên quan",
                    "record": "Bản ghi",
                    "heading": "Đơn xin nghỉ việc",
                    "employee": "Nhân sự cần tạo đơn",
                    "name": "Họ và tên",
                    "department": "Phòng ban",
                    "jobPosition": "Vị trí",
                    "jobTitle": "Chức vụ",
                    "pending": "Đang chờ duyệt",
                    "approved": "Đã duyệt",
                    "work": "Công việc",
                    "project": "Dự án"
                },
                "rule": {
                    "reason": "Vui lòng chọn lý do!",
                    "resignationDate": "Vui lòng chọn ngày nghỉ việc!",
                    "employee": "Vui lòng chọn nhân sự cần tạo đơn!"
                }
            },
            "missions": {
                "headingLabel": "Đơn công tác",
                "addMission": "Tạo đơn công tác",
                "updateMission": "Cập nhật đơn công tác",
                "forElse": {
                    "headingLabel": "Tạo đơn công tác hộ người khác"
                },
                "detailInformation": "Chi tiết đơn công tác",
                "placeholder": {
                    "reason": "Chọn lý do",
                    "resignationDate": "DD/MM/YYYY",
                    "description": "Nhập mô tả...",
                    "relateObject": "Đối tượng liên quan",
                    "record": "Chọn bản ghi",
                    "employee": "Chọn nhân sự",
                    "address": "Nhập địa điểm...",
                    "missionVehicle": "Chọn phương tiện",
                    "sum": "Tổng",
                    "missionFee": "Phụ phí đi lại, ăn trưa...",
                    "domestic": "Trong nước",
                    "oversea": "Nước ngoài",
                    "from": "Từ",
                    "to": "Đến",
                    "vehicle": "Phương tiện"
                },
                "label": {
                    "reason": "Lý do công tác",
                    "description": "Nội dung liên quan",
                    "relateObject": "Đối tượng liên quan",
                    "record": "Bản ghi",
                    "heading": "Đơn công tác",
                    "employee": "Nhân sự cần tạo đơn",
                    "name": "Họ và tên",
                    "department": "Phòng ban",
                    "jobPosition": "Vị trí",
                    "jobTitle": "Chức vụ",
                    "pending": "Đang chờ duyệt",
                    "approved": "Đã duyệt",
                    "work": "Công việc",
                    "project": "Dự án",
                    "startTime": "Từ giờ",
                    "endTime": "Đến giờ",
                    "startDate": "Từ ngày",
                    "endDate": "Đến ngày",
                    "address": "Địa điểm công tác",
                    "missionVehicle": "Phương tiện công tác",
                    "typeOversea": "Hình thức công tác",
                    "oversea": "Công tác nước ngoài",
                    "missionFee": "Phụ phí công tác",
                    "missionFeeName": "Tên phụ phí",
                    "missionFeeAmount": "Số tiền",
                    "sum": "Tổng phụ phí"
                },
                "rule": {
                    "reason": "Vui lòng chọn lý do công tác!",
                    "employee": "Vui lòng chọn nhân sự cần tạo đơn!",
                    "address": "Vui lòng nhập địa điểm công tác",
                    "startTime": "Giờ bắt đầu chưa nhập",
                    "endTime": "Giờ kết thúc chưa nhập",
                    "startDate": "Ngày bắt đầu chưa nhập",
                    "endDate": "Ngày kết thúc chưa nhập",
                    "content": "Vui lòng nhập nội dung công việc"
                }
            },
            "shiftChange": {
                "detail": "Chi tiết đơn đổi ca",
                "headingLabel": "Đơn đổi ca",
                "addNew": "Tạo mới đơn đổi ca",
                "forElse": {
                    "headingLabel": "Tạo đơn đổi ca hộ người khác"
                },
                "differentTime": "Đơn với các khoảng thời gian khác nhau",
                "employeeNeedApplication": "Nhân sự cần tạo đơn",
                "update": "Cập nhật đơn đổi ca",
                "typeShiftChange": "Kiểu đổi ca",
                "chooseType": "Chọn kiểu đổi ca",
                "myself": "Chính mình",
                "others": "Người khác",
                "dayNeedChange": "Ngày cần đổi",
                "shiftNeedChange": "Ca cần đổi",
                "dateChange": "Ngày đổi ca",
                "personChange": "Người đổi",
                "shiftWantChange": "Ca muốn đổi",
                "placeholder": {
                    "date": "DD/MM/YYYY",
                    "shiftNeedChange": "Nhập ca cần đổi",
                    "shiftWantChange": "Nhập ca muốn đổi",
                    "personChange": "Nhập người đổi",
                    "employeeNeedApplication": "Nhập nhân sự cần tạo đơn"
                },
                "columnsDetail": {
                    "dateChange": "Ngày cần đổi",
                    "appOwnerId": "Người đổi",
                    "dateWant": "Ngày muốn đổi",
                    "shiftWant": "Ca muốn đổi"
                },
                "required": {
                    "dayrequired": "Ngày đổi ca là trường bắt buộc",
                    "shift1": "Ca cần đổi là trường bắt buộc",
                    "dayrequired2": "Ngày đổi là trường bắt buộc",
                    "employeeChange": "Người đổi là trường bắt buộc",
                    "shift2": "Ca muốn đổi là trường bắt buộc"
                }
            },
            "overtime": {
                "headingLabel": "Đơn làm thêm",
                "addNew": "Tạo mới đơn làm thêm",
                "update": "Cập nhật đơn làm thêm",
                "detail": "Chi tiết đơn làm thêm",
                "forElse": {
                    "headingLabel": "Tạo đơn làm thêm hộ người khác"
                },
                message: {
                    error: {
                        fromTime: "Từ giờ là bắt buộc",
                        toTime: "Đến giờ là bắt buộc"
                    }
                },
                "day": "Ngày làm thêm",
                "fromDay": "Từ giờ",
                "toDay": "Đến giờ",
                "shiftId": "Ca làm việc",
                "type": "Kiểu",
                "latch": "Chốt",
                "time": "Thời gian làm thêm",
                "total": "Tổng giờ",
                "note": "Ghi chú"
            },
            "shiftMore": {
                "headingLabel": "Đơn tăng ca",
                "addNew": "Tạo mới đơn tăng ca",
                "update": "Cập nhật đơn tăng ca",
                "detail": "Chi tiết đơn tăng ca",
                "forElse": {
                    "headingLabel": "Tạo đơn tăng ca hộ người khác"
                },
                message: {
                    error: {
                        date: "Ngày tăng ca bắt buộc chọn"
                    }
                },
                "currentShift": "Ca được phân",
                "requestShift": "Ca tăng",
                "date": "Ngày tăng ca",
                "type": "Kiểu",
                "attendance": "Yêu cầu chốt",
                "total": "Tổng giờ",
                "placeholder": {
                    "date": "DD/MM/YYYY",
                    "shiftNeedChange": "Nhập ca cần đổi",
                    "shiftWantChange": "Nhập ca muốn đổi",
                    "personChange": "Nhập người đổi"
                }
            },
            "shiftRegistration": {
                "headingLabel": "Đơn đăng kí ca",
                headingDetailLabel: "Chi tiết đăng ký ca",
                "addNew": "Tạo mới đơn đăng kí ca",
                "update": "Cập nhật đơn đăng kí ca",
                "detail": "Chi tiết đơn đăng kí ca",
                "forElse": {
                    "headingLabel": "Tạo đơn tăng ca hộ người khác"
                },
                typeShift: {
                    range: "Theo khoảng ngày",
                    fixed: "Theo ngày cố định"
                },
                "currentShift": "Ca được phân",
                "requestShift": "Ca tăng",
                "date": "Ngày tăng ca",
                "type": "Kiểu",
                "attendance": "Yêu cầu chốt",
                "placeholder": {
                    "date": "DD/MM/YYYY",
                    "shiftNeedChange": "Nhập ca cần đổi",
                    "shiftWantChange": "Nhập ca muốn đổi",
                    "personChange": "Nhập người đổi"
                },
                "dayShiftOfWeek": {
                    "monday": "Thứ hai",
                    "tuesday": "Thứ ba",
                    "wednesday": "Thứ tư",
                    "thursday": "Thứ năm",
                    "friday": "Thứ sáu",
                    "saturdayOdd": "Thứ bảy chẵn",
                    "saturdayEven": "Thứ bảy lẻ",
                    "sunday": "Chủ nhật"
                },
            },
            "leave": {
                "headingLabel": "Đơn xin nghỉ",
                "addNew": "Tạo mới đơn xin nghỉ",
                "update": "Cập nhật đơn xin nghỉ",
                "startHour": "Từ giờ",
                "detail": "Chi tiết đơn xin nghỉ",
                "endHour": "Đến giờ",
                "startDate": "Từ ngày",
                "endDate": "Đến ngày",
                "isRequired": "chưa nhập",
                "timeAdd": "Số giờ thêm",
                "used": "Đã dùng",
                "canLeave": "Có thể nghỉ",
                "canAdvance": "Có thể ứng",
                "residualLeave": "Phép dư",
                "shift": "Ca",
                "firstHalfShift": "Nửa ca đầu",
                "lastHalfShift": "Nửa ca sau",
                "option": {
                    "day/year": "ngày/năm",
                    "day/month": "ngày/tháng",
                    "day/week": "ngày/tuần",
                    "days/year": "ngày/năm",
                    "days/month": "ngày/tháng",
                    "days/week": "ngày/tuần"
                },
                "forElse": {
                    "headingLabel": "Tạo đơn xin nghỉ hộ người khác"
                },
                "columnsDetail": {
                    "startDate": "Bắt đầu",
                    "endDate": "Kết thúc",
                    "duration": "Thời lượng",
                    "timeByShift": "Thời gian theo ca"
                },
                "unit": {
                    "date": "Ngày",
                    "minute": "Phút",
                    "hour": "Giờ"
                },
                "validate": {
                    "date": "Chưa nhập ngày",
                    "hour": "Chưa nhập giờ",
                    "reason": "Chưa chọn lý do",
                    "ownerId": "Chưa nhập nhân viên cần tạo đơn"
                },
                "placeholder": {
                    "reason": "Chọn lý do",
                    "shift": "Chọn ca làm việc",
                    "description": "Nhập mô tả"
                }
            },
            "shift": {
                "headingLabel": "Đơn đăng ký ca",
                "detailInformation": "Chi tiết đơn đăng ký ca",
                "forElse": {
                    "headingLabel": "Tạo đơn đăng ký ca hộ người khác"
                },
                "label": {
                    "type": "Kiểu đăng ký",
                    "date": "Ngày",
                    "shift": "Ca",
                    "detailShift": "Chi tiết đăng ký ca",
                    "detailApp": "Chi tiết đơn",
                    "detail": "Chi tiết",
                    "description": "Mô tả",
                    "dateTable": "Ngày đăng ký",
                    "shiftTable": "Ca làm việc",
                    "totalHour": "Tổng số giờ",
                    "hour": "giờ",
                    "minute": "phút"
                },
                "placeholder": {
                    "startDate": "Ngày bắt đầu",
                    "endDate": "Ngày kết thúc",
                    "shift": "Chọn ca làm việc"
                },
                "typeShift": {
                    "range": "Theo khoảng ngày",
                    "fixed": "Theo ngày cố định"
                }
            },
            "absence": {
                "addAbsence": "Tạo đơn vắng mặt ",
                "forElse": {
                    "headingLabel": "Tạo đơn vắng mặt hộ người khác"
                },
                "update": "Cập nhật đơn vắng mặt",
                "detail": "Chi tiết đơn vắng mặt",
                "label": {
                    "dayOff": "Ngày nghỉ",
                    "fromNow": "Từ giờ",
                    "toNow": "Đến giờ",
                    "reason": "Lý do vắng mặt ",
                    "workCalculation": "Tính công ",
                    "closingRequest": "Yêu cầu chốt",
                    "description": "Mô tả",
                    "relatedObjects": "Đối tượng liên quan ",
                    "record": "Bản ghi",
                    "createMany": "Tạo đơn cho nhiều người",
                    "different": "Đơn với các khoảng thời gian khác nhau"
                },
                "placeholder": {
                    "yes": "Có",
                    "no": "Không",
                    "selectReason": "Chọn lý do vắng mặt "
                }
            },
            "late": {
                "headingLabel": "Đơn đi muộn về sớm",
                "late": "Tạo đơn đi muộn về sớm",
                "other": {
                    "late": "Tạo hộ đơn đi muộn về sớm"
                },
                "update": "Cập nhnhậpập đơn đi muộn về sớm",
                "detail": "Chi tiếtnhập đơn đi muộn về sớm",
                "label": {
                    "daylate": "Ngày đi muộn về sớm",
                    "type": "Hình thức",
                    "shiftlate": "Ca làm việc",
                    "from": "Từ giờ",
                    "to": "Đến giờ",
                    "late": "Giờ đi muộn",
                    "leave": "Giờ về sớm",
                    "daymake": "Ngày làm bù",
                    "employee": "Nhân sự cần tạo đơn",
                    "total": "Tổng giờ",
                    "daycreator": "Ngày tạo",
                    "timeMake": "Thời gian",
                    "compensationDetail": "Chi tiết làm bù",
                    "compensationTime": "Thời gian làm bù"
                },
                "type": {
                    "late": "Đi muộn",
                    "leave": "Về sớm",
                    "absence": "Vắng mặt giữa giờ"
                },
                "message": {
                    "add": "Thêm đơn đi muộn về sớm thành công!",
                    "update": "Sửa đơn đi muộn về sớm thành công!"
                },
                "placeholder": {
                    "employee": "Chọn nhân sự cần tạo đơn"
                }
            }
        },
        "name": {
            "inout": "Đơn check in check out",
            "flexible": "Đơn làm theo chế độ",
            "resign": "Đơn nghỉ việc",
            "shift swap": "Đơn đổi ca",
            "missions": "Đơn công tác",
            "overtime": "Đơn làm thêm",
            "absence": "Đơn vắng mặt",
            "leave": "Đơn xin nghỉ",
            "shift more": "Đơn tăng ca",
            "shift registration": "Đơn đăng ký ca",
            "late": "Đơn xin đi muộn về sớm"
        }
    }
}